/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { EventsPage } from '../model/eventsPage';
import { EventsPageCreateInput } from '../model/eventsPageCreateInput';
import { EventsPageList } from '../model/eventsPageList';
import { EventsPageUpdateInput } from '../model/eventsPageUpdateInput';
import { Model26 } from '../model/model26';
import { Model83 } from '../model/model83';
import { Model84 } from '../model/model84';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EventsPageService {

    protected basePath = 'http://localhost:5001';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Delete a EventsPage
     * 
     * @param orgName 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrgsOrgnameEventspageId(orgName: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteOrgsOrgnameEventspageId(orgName: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteOrgsOrgnameEventspageId(orgName: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteOrgsOrgnameEventspageId(orgName: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling deleteOrgsOrgnameEventspageId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteOrgsOrgnameEventspageId.');
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/EventsPage/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all EventsPage(s)
     * 
     * @param orgName 
     * @param populate 
     * @param archived 
     * @param inlineBlob 
     * @param filter 
     * @param where 
     * @param offset 
     * @param page 
     * @param limit 
     * @param sortBy 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameEventspage(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'body', reportProgress?: boolean): Observable<EventsPageList>;
    public getOrgsOrgnameEventspage(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventsPageList>>;
    public getOrgsOrgnameEventspage(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventsPageList>>;
    public getOrgsOrgnameEventspage(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameEventspage.');
        }










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (archived !== undefined && archived !== null) {
            queryParameters = queryParameters.set('archived', <any>archived);
        }
        if (inlineBlob !== undefined && inlineBlob !== null) {
            queryParameters = queryParameters.set('inlineBlob', <any>inlineBlob);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sortBy !== undefined && sortBy !== null) {
            queryParameters = queryParameters.set('sortBy', <any>sortBy);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EventsPageList>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/EventsPage`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the count of all EventsPage(s)
     * 
     * @param orgName 
     * @param where 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameEventspageCount(orgName: string, where?: string, observe?: 'body', reportProgress?: boolean): Observable<Model26>;
    public getOrgsOrgnameEventspageCount(orgName: string, where?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Model26>>;
    public getOrgsOrgnameEventspageCount(orgName: string, where?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Model26>>;
    public getOrgsOrgnameEventspageCount(orgName: string, where?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameEventspageCount.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Model26>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/EventsPage/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get EventsPage
     * 
     * @param orgName 
     * @param id 
     * @param populate 
     * @param inlineBlob 
     * @param filter 
     * @param where 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameEventspageId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'body', reportProgress?: boolean): Observable<EventsPage>;
    public getOrgsOrgnameEventspageId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventsPage>>;
    public getOrgsOrgnameEventspageId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventsPage>>;
    public getOrgsOrgnameEventspageId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameEventspageId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrgsOrgnameEventspageId.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (inlineBlob !== undefined && inlineBlob !== null) {
            queryParameters = queryParameters.set('inlineBlob', <any>inlineBlob);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EventsPage>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/EventsPage/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get EventsPage field
     * 
     * @param orgName 
     * @param id 
     * @param fieldName 
     * @param populate 
     * @param q 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameEventspageIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getOrgsOrgnameEventspageIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getOrgsOrgnameEventspageIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getOrgsOrgnameEventspageIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameEventspageIdFieldname.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrgsOrgnameEventspageIdFieldname.');
        }

        if (fieldName === null || fieldName === undefined) {
            throw new Error('Required parameter fieldName was null or undefined when calling getOrgsOrgnameEventspageIdFieldname.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any>q);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/EventsPage/${encodeURIComponent(String(id))}/${encodeURIComponent(String(fieldName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a EventsPage
     * 
     * @param orgName 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgsOrgnameEventspage(orgName: string, body?: EventsPageCreateInput, observe?: 'body', reportProgress?: boolean): Observable<EventsPage>;
    public postOrgsOrgnameEventspage(orgName: string, body?: EventsPageCreateInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventsPage>>;
    public postOrgsOrgnameEventspage(orgName: string, body?: EventsPageCreateInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventsPage>>;
    public postOrgsOrgnameEventspage(orgName: string, body?: EventsPageCreateInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling postOrgsOrgnameEventspage.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventsPage>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/EventsPage`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Import multiple EventsPage
     * 
     * @param orgName 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgsOrgnameEventspageImport(orgName: string, body?: Model83, observe?: 'body', reportProgress?: boolean): Observable<Model84>;
    public postOrgsOrgnameEventspageImport(orgName: string, body?: Model83, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Model84>>;
    public postOrgsOrgnameEventspageImport(orgName: string, body?: Model83, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Model84>>;
    public postOrgsOrgnameEventspageImport(orgName: string, body?: Model83, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling postOrgsOrgnameEventspageImport.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Model84>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/EventsPage/import`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a EventsPage
     * 
     * @param orgName 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putOrgsOrgnameEventspageId(orgName: string, id: string, body?: EventsPageUpdateInput, observe?: 'body', reportProgress?: boolean): Observable<EventsPage>;
    public putOrgsOrgnameEventspageId(orgName: string, id: string, body?: EventsPageUpdateInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventsPage>>;
    public putOrgsOrgnameEventspageId(orgName: string, id: string, body?: EventsPageUpdateInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventsPage>>;
    public putOrgsOrgnameEventspageId(orgName: string, id: string, body?: EventsPageUpdateInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling putOrgsOrgnameEventspageId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putOrgsOrgnameEventspageId.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<EventsPage>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/EventsPage/${encodeURIComponent(String(id))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Publish a EventsPage
     * 
     * @param orgName 
     * @param id 
     * @param published 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putOrgsOrgnameEventspageIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'body', reportProgress?: boolean): Observable<EventsPage>;
    public putOrgsOrgnameEventspageIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventsPage>>;
    public putOrgsOrgnameEventspageIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventsPage>>;
    public putOrgsOrgnameEventspageIdPublishedPublished(orgName: string, id: string, published: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling putOrgsOrgnameEventspageIdPublishedPublished.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putOrgsOrgnameEventspageIdPublishedPublished.');
        }

        if (published === null || published === undefined) {
            throw new Error('Required parameter published was null or undefined when calling putOrgsOrgnameEventspageIdPublishedPublished.');
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<EventsPage>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/EventsPage/${encodeURIComponent(String(id))}/published/${encodeURIComponent(String(published))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
